// extracted by mini-css-extract-plugin
export default {"city":"WeatherInfo_city__bEU7f","info":"WeatherInfo_info__rYHjF","image":"WeatherInfo_image__rAAfI","degree":"WeatherInfo_degree__L-Smh"};